import { curry } from 'lodash';
import React from 'react';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

import buildRefetchQueries from './buildRefetchQueries';

export const NAME =
  'compositions_TechAdmin_Contacts_updateAfterHoursEventsContacts';

const mutation = gql`
  mutation ${NAME} (
    $eventIds: [ID!]!
    $primaryContactId: ID
    $backupContactId: ID
    $finalContactId: ID
  ) {
    updateAfterHoursEventsContacts(
      input: {
        ids: $eventIds,
        patch: {
          primaryContactId: $primaryContactId
          backupContactId: $backupContactId
          finalContactId: $finalContactId
        }
      }
    ) {
      events {
        id
      }
    }
  }
`;

export const buildMutationChild = curry(
  (WrappedComponent, componentProps, updateAfterHoursEventsContacts) => (
    <WrappedComponent
      {...componentProps}
      updateAfterHoursEventsContacts={variables =>
        updateAfterHoursEventsContacts({
          variables,
        })
      }
    />
  ),
);

function buildWrappedComponentWithMutation(WrappedComponent, componentProps) {
  return (
    <Mutation
      mutation={mutation}
      refetchQueries={buildRefetchQueries(componentProps)}
    >
      {buildMutationChild(WrappedComponent, componentProps)}
    </Mutation>
  );
}

const withUpdateAfterHoursEventsContacts = WrappedComponent => componentProps =>
  buildWrappedComponentWithMutation(WrappedComponent, componentProps);

export default withUpdateAfterHoursEventsContacts;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Contacts/DeleteContactModal/withUpdateAfterHoursEventsContacts.js